// extracted by mini-css-extract-plugin
export default {"card":"style_card__lahLl","btn":"style_btn__rrTdZ","form":"style_form__UlB0H","commentinput":"style_commentinput__+S33q"};